import { AfterViewInit, Component, Input, OnInit,EventEmitter, Output, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, UntypedFormControl, Validators } from '@angular/forms';
import { NzAutocompleteOptionComponent } from 'ng-zorro-antd/auto-complete';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { DbListSelect } from 'src/app/interfaces/db-list-select';
import { HTTPService } from 'src/app/services/http.service';
import { ObjectUtil } from '../utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'input-autocomplete',
    templateUrl: './input-autocomplete.component.html',
    styleUrls: ['./input-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InputAutocompleteComponent implements AfterViewInit, OnInit, OnChanges {

  sub:Subscription;

  constructor( private httpService:HTTPService,public ThemeService:ThemeService,  private changeDetectorRef: ChangeDetectorRef) {
    this.selectItem = new EventEmitter();

  }

  ngOnChanges(changes: SimpleChanges): void {
    (changes.controle.currentValue as UntypedFormControl).updateValueAndValidity();
    this.syncDisplayValue();
    this.changeDetectorRef.detectChanges();
  }

  writeValue(obj: any): void {
    if ( obj ){
      this.controle.setValue(obj);
      this.syncDisplayValue();
    }
  }


  click(){
  }

  ngOnDestroy(){
      if (this.sub!= null ) {this.sub.unsubscribe();}
  }

  ngAfterViewInit(): void {

    this.controle.setValidators(RequireMatch);

    if ( this.required ){
      this.controle.setValidators([Validators.required,RequireMatch]);
    }

    if ( this.disabled ){
      this.controle.disable();
    }else{
      this.controle.enable();
    }

    this.filteredOptions = this.controle.valueChanges.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(value => this._filter(value))
    );

    this.syncDisplayValue();
    this.refresh(null);
  }


  refresh(condition:string){

    return new Promise((resolve,reject)=>{
      let body = {
        "entityName":this.entityName,
        "rows":10,
        "showPresentation":false,
        "showRelationshipData":false,
        "showRelationship":false,
      }

      if ( condition != null ){
        body['condition'] = condition;
      }

      this.list = [];
      this.isLoading = true;
      this.changeDetectorRef.markForCheck();
      this.sub = this.httpService.post(body,"JsonBrokerServices/find",false,true,true).subscribe(x=>{

          this.transformDbSelect(x[this.entityName]);
          this.afterLoad.emit(true);
          this.isLoading = false;
          this.changeDetectorRef.markForCheck();
          resolve(this.list);
      },error=>{
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
        reject();
      })

    });

  }

  transformDbSelect(rows:object[]){

      rows.forEach(row=>{
        var descCol = row[this.config.descColumn];
        var keyCol = row[this.config.keyColumn];
        this.list.push({id:keyCol,name:descCol});
      })

  }

  @Input() controle:UntypedFormControl;
  @Input() labelName:string;
  @Input() entityName:string;
  @Input() config:{descColumn:string, keyColumn:string}
  @Input() required:boolean = false;
  @Input() disabled:boolean = false;

  condition;

  displayValue:string = '';
  list:DbListSelect[] = [];
  filteredOptions: Observable<DbListSelect[]>;
  isLoading = false;
  @Output('selectItem') selectItem:EventEmitter<DbListSelect> = new EventEmitter();
  @Output('afterLoad') afterLoad:EventEmitter<Boolean> = new EventEmitter();

  ngOnInit(): void {

  }

  /* mantém o texto exibido em sincronia quando o controle já contém um objeto selecionado */
  private syncDisplayValue(){
    let value = this.controle != null ? this.controle.value : null;
    if ( value != null && typeof(value) != 'string' ){
      this.displayValue = this.getOptionText(value);
    }
  }

  /* digitação livre alimenta o pipeline de filtro; seleção chega como objeto e é ignorada aqui */
  onType(value){
    if ( typeof(value) == 'string' ){
      this.controle.setValue(value);
      this.controle.markAsDirty();
    }
  }

  clear(){
    this.displayValue = '';
    this.controle.setValue('');
    this.changeDetectorRef.markForCheck();
  }

  getSelectedAutoComplete(option:NzAutocompleteOptionComponent){

    if ( option != null){
      let value:DbListSelect = option.nzValue;
      this.controle.setValue(value);
      this.displayValue = this.getOptionText(value);
      this.selectItem.emit(value);
      this.changeDetectorRef.markForCheck();
    }
  }


  getOptionText(option:DbListSelect){
      return option && option.name ? option.id + ' - ' + option.name : '';
  }


  update(value){

  }


  private _filter(value: string): DbListSelect[] {

    if ( value != null && value !='' && ( typeof(value) == 'string' )){

      const filterValue = value;
      if ( ObjectUtil.isNotEmpty(filterValue )){
        this.controle.setValue('');
        let condition = "(" + this.config.descColumn + " like '%" + filterValue + "%' OR " + this.config.keyColumn +" like '%" + filterValue + "%')"
        this.refresh(condition).then(list=>{
          return this.list;//.filter(option => option.name.toLowerCase().includes(filterValue));
        }).catch(x=>{
            return this.list;
        });
      }
      return this.list;

    }else{
      return this.list;
    }

  }
}


export function RequireMatch(control: AbstractControl) {
  const selection: any = control.value;

  if (typeof selection === "string") {
    return { incorrect: true };
  }
  return null;
}
